angular.module('impactx.usergroups').controller('EditUserGroupController', EditUserGroupController);
EditUserGroupController.$inject = [
    '$scope',
    'dataGen',
    'BackService',
    'ToastService',
    'ConfirmationService',
    '$routeParams',
    'ToolbarService',
    'TranslationService',
    '$redirect',
];

function EditUserGroupController($scope, dataGen, BackService,ToastService, ConfirmationService, $routeParams, ToolbarService, TranslationService, $redirect) {
    var ctrl = this;
    $scope.currentComId = 0;

    dataGen.getData($scope, {id: $routeParams.id}, "/usergroup/view").then(function () {
        defineButtons();
        $scope.currentComId = $scope.data.company.selected.id;
    });

    ctrl.save = function () {
        var dataObj = {
            data: $scope.data
        };
        return dataGen.postAsForm($scope, dataObj, "/usergroup/save").then(function () {
            BackService.back();
            ToastService.openStandardToast(TranslationService.get('saveSuccess'));
        });
    };

    ctrl.saveAndRedirect = function () {
        var dataObj = {
            data: $scope.data
        };
        return dataGen.postAsForm($scope, dataObj, "/usergroup/save").then(function (data) {
            if (data) {
                $redirect.redirectTo(null, "usergroup/catalogright/" + data.data.id);
            }
        });
    };

    ctrl.deleteDialog = function (event) {
        ConfirmationService.showConfirmationDialog(ctrl.delete, event, TranslationService.get("deleteQuestionSingleObject"),
            TranslationService.get("delete"), TranslationService.get("abort"));
    };

    ctrl.delete = function () {
        var dataObj = {
            id: $scope.data.id
        };
        dataGen.getData($scope, dataObj, "/usergroup/delete").then(function () {
            BackService.back();
            ToastService.openStandardToast(TranslationService.get('deleteSuccess'));
        });
    };
    function defineButtons() {
        var buttonDefinition = [
            {
                label: TranslationService.get("save"),
                action: ctrl.save,
                type: 'validation',
                params: {
                    form: $scope.dialogData
                }
            },
            {
                label: $scope.trns.saveAndRedirect,
                action: ctrl.saveAndRedirect,
                type: 'validation',
                params: {
                    form: $scope.dialogData
                }
            },
            {
                label: TranslationService.get("delete"),
                action: ctrl.deleteDialog,
                type: 'dialogaction',
                condition: canDelete
            }
        ];
        ToolbarService.setButtons(buttonDefinition);
    }

    function canDelete() {
        return $scope.data.id > 0 && !$scope.data.isDeprecated;
    }
}